var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgHome01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 444,
    viewBox: "0 0 588 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_5014)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 588,
    height: 444,
    rx: 12,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 137,
    width: 191,
    height: 191,
    rx: 39,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -68,
    y: 137,
    width: 191,
    height: 191,
    rx: 39,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.245 158.91C254.921 167.267 244.25 173.78 231.282 173.78C217.847 173.78 206.877 166.789 206.212 158L160.398 160.743C157.366 160.925 155 163.437 155 166.475V198.696C155 202.219 158.144 204.911 161.626 204.369L172.791 202.629C176.496 202.051 179.75 205.122 179.39 208.854L170.91 296.645C170.591 299.946 173.127 302.83 176.442 302.935L270.67 305.944C273.911 306.047 276.595 303.448 276.595 300.205V212.473C276.595 208.828 279.948 206.105 283.516 206.854L296.079 209.491C299.647 210.24 303 207.517 303 203.872V172.654C303 169.902 301.047 167.536 298.344 167.016L256.245 158.91Z",
    fill: "#4DC380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4 224.367C222.959 226.764 221.008 229.268 218.898 229.76C216.789 230.253 214.017 228.85 213.458 226.453C212.899 224.056 214.512 220.862 216.622 220.37C219.435 219.713 221.84 221.969 222.4 224.367Z",
    fill: "#37B36B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.164 224.458C232.352 226.782 234.025 229.48 236.071 230.194C238.116 230.909 241.02 229.809 241.832 227.485C242.643 225.161 241.379 221.814 239.334 221.1C236.607 220.147 233.975 222.134 233.164 224.458Z",
    fill: "#37B36B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.267 238.108C242.892 245.132 235.894 247.376 226.537 246.877C217.181 246.377 210.617 243.408 210.992 236.385C211.428 228.214 216.92 221.967 227.837 222.55C238.753 223.133 243.737 229.321 243.267 238.108Z",
    fill: "#37B36B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.996 235.021C224.888 237.059 223.508 239.227 221.746 239.133C219.984 239.039 217.227 237.226 217.389 234.183C217.542 231.323 220.671 230.471 223.82 231.163C225.75 231.587 225.105 232.984 224.996 235.021Z",
    fill: "#269E58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.717 234.542C221.696 234.941 221.799 235.271 222.401 235.303C223.004 235.335 223.141 235.018 223.163 234.619C223.184 234.22 222.96 233.884 222.479 233.858C221.997 233.832 221.739 234.143 221.717 234.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.488 235.261C229.379 237.299 230.52 239.601 232.282 239.695C234.044 239.789 236.978 238.281 237.141 235.237C237.294 232.378 234.273 231.197 231.069 231.55C229.104 231.766 229.596 233.223 229.488 235.261Z",
    fill: "#269E58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.799 235.133C232.778 235.532 232.64 235.849 232.038 235.817C231.436 235.785 231.333 235.455 231.354 235.056C231.375 234.657 231.633 234.346 232.115 234.372C232.597 234.398 232.82 234.734 232.799 235.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 137.949C390.721 129.213 383.199 122.275 373.726 122.275C370.662 122.275 365.925 124.331 363.975 127.671C363.697 128.442 362.582 128.442 362.303 127.671C360.075 124.588 355.617 122.532 352.274 122.532C343.08 122.532 335.279 129.47 335 137.949V138.463C335 142.831 336.95 146.942 340.294 150.025C340.572 150.282 353.945 161.331 360.075 166.213C361.746 167.498 364.254 167.498 365.925 166.213C372.055 161.331 385.149 150.539 385.706 150.282C385.706 150.282 385.706 150.282 385.706 150.025C389.05 147.199 391 143.088 391 138.463V137.949Z",
    fill: "url(#paint0_linear_66_5014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.984 91.0006C339.135 86.7006 334.027 84.7216 329.305 86.5845C327.777 87.1871 325.818 89.1432 325.5 91.1919C325.512 91.6309 324.957 91.8501 324.667 91.5206C322.952 90.4219 320.328 90.2739 318.661 90.9313C314.078 92.7394 311.547 97.7318 313.068 102.013L313.169 102.269C314.024 104.447 315.801 106.113 318.071 106.992C318.261 107.066 327.09 109.943 331.101 111.172C332.186 111.483 333.436 110.99 334.018 110.021C336.117 106.382 340.532 98.4273 340.76 98.1897C340.76 98.1897 340.76 98.1897 340.709 98.0616C341.822 95.9952 341.99 93.5623 341.084 91.2568L340.984 91.0006Z",
    fill: "url(#paint1_linear_66_5014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.813 92.9101C389.729 88.6397 387.737 83.527 383.178 81.2936C381.703 80.571 378.941 80.4436 377.218 81.5914C376.903 81.8967 376.367 81.634 376.414 81.1973C376.065 79.1877 374.402 77.1474 372.793 76.3591C368.367 74.1913 362.984 75.691 360.86 79.7063L360.74 79.9536C359.714 82.0559 359.688 84.4944 360.573 86.7667C360.647 86.9561 364.49 95.4269 366.294 99.2218C366.797 100.234 368.004 100.825 369.11 100.601C373.206 99.6968 382.042 97.5902 382.37 97.5979C382.37 97.5979 382.37 97.5979 382.43 97.4743C384.703 96.9022 386.607 95.3834 387.692 93.1574L387.813 92.9101Z",
    fill: "url(#paint2_linear_66_5014)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 137,
    width: 191,
    height: 191,
    rx: 39,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.245 158.91C254.921 167.267 244.25 173.78 231.282 173.78C217.847 173.78 206.877 166.789 206.212 158L160.398 160.743C157.366 160.925 155 163.437 155 166.475V198.696C155 202.219 158.144 204.911 161.626 204.369L172.791 202.629C176.496 202.051 179.75 205.122 179.39 208.854L170.91 296.645C170.591 299.946 173.127 302.83 176.442 302.935L270.67 305.944C273.911 306.047 276.595 303.448 276.595 300.205V212.473C276.595 208.828 279.948 206.105 283.516 206.854L296.079 209.491C299.647 210.24 303 207.517 303 203.872V172.654C303 169.902 301.047 167.536 298.344 167.016L256.245 158.91Z",
    fill: "#4DC380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4 224.367C222.959 226.764 221.008 229.268 218.898 229.76C216.789 230.253 214.017 228.85 213.458 226.453C212.899 224.056 214.512 220.862 216.622 220.37C219.435 219.713 221.84 221.969 222.4 224.367Z",
    fill: "#37B36B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.164 224.458C232.352 226.782 234.025 229.48 236.071 230.194C238.116 230.909 241.02 229.809 241.832 227.485C242.643 225.161 241.379 221.814 239.334 221.1C236.607 220.147 233.975 222.134 233.164 224.458Z",
    fill: "#37B36B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.267 238.108C242.892 245.132 235.894 247.376 226.537 246.877C217.181 246.377 210.617 243.408 210.992 236.385C211.428 228.214 216.92 221.967 227.837 222.55C238.753 223.133 243.737 229.321 243.267 238.108Z",
    fill: "#37B36B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.996 235.021C224.888 237.059 223.508 239.227 221.746 239.133C219.984 239.039 217.227 237.226 217.389 234.183C217.542 231.323 220.671 230.471 223.82 231.163C225.75 231.587 225.105 232.984 224.996 235.021Z",
    fill: "#269E58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.717 234.542C221.696 234.941 221.799 235.271 222.401 235.303C223.004 235.335 223.141 235.018 223.163 234.619C223.184 234.22 222.96 233.884 222.479 233.858C221.997 233.832 221.739 234.143 221.717 234.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.488 235.261C229.379 237.299 230.52 239.601 232.282 239.695C234.044 239.789 236.978 238.281 237.141 235.237C237.294 232.378 234.273 231.197 231.069 231.55C229.104 231.766 229.596 233.223 229.488 235.261Z",
    fill: "#269E58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.799 235.133C232.778 235.532 232.64 235.849 232.038 235.817C231.436 235.785 231.333 235.455 231.354 235.056C231.375 234.657 231.633 234.346 232.115 234.372C232.597 234.398 232.82 234.734 232.799 235.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 137.949C390.721 129.213 383.199 122.275 373.726 122.275C370.662 122.275 365.925 124.331 363.975 127.671C363.697 128.442 362.582 128.442 362.303 127.671C360.075 124.588 355.617 122.532 352.274 122.532C343.08 122.532 335.279 129.47 335 137.949V138.463C335 142.831 336.95 146.942 340.294 150.025C340.572 150.282 353.945 161.331 360.075 166.213C361.746 167.498 364.254 167.498 365.925 166.213C372.055 161.331 385.149 150.539 385.706 150.282C385.706 150.282 385.706 150.282 385.706 150.025C389.05 147.199 391 143.088 391 138.463V137.949Z",
    fill: "url(#paint3_linear_66_5014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.984 91.0006C339.135 86.7006 334.027 84.7216 329.305 86.5845C327.777 87.1871 325.818 89.1432 325.5 91.1919C325.512 91.6309 324.957 91.8501 324.667 91.5206C322.952 90.4219 320.328 90.2739 318.661 90.9313C314.078 92.7394 311.547 97.7318 313.068 102.013L313.169 102.269C314.024 104.447 315.801 106.113 318.071 106.992C318.261 107.066 327.09 109.943 331.101 111.172C332.186 111.483 333.436 110.99 334.018 110.021C336.117 106.382 340.532 98.4273 340.76 98.1897C340.76 98.1897 340.76 98.1897 340.709 98.0616C341.822 95.9952 341.99 93.5623 341.084 91.2568L340.984 91.0006Z",
    fill: "url(#paint4_linear_66_5014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.813 92.9101C389.729 88.6397 387.737 83.527 383.178 81.2936C381.703 80.571 378.941 80.4436 377.218 81.5914C376.903 81.8967 376.367 81.634 376.414 81.1973C376.065 79.1877 374.402 77.1474 372.793 76.3591C368.367 74.1913 362.984 75.691 360.86 79.7063L360.74 79.9536C359.714 82.0559 359.688 84.4944 360.573 86.7667C360.647 86.9561 364.49 95.4269 366.294 99.2218C366.797 100.234 368.004 100.825 369.11 100.601C373.206 99.6968 382.042 97.5902 382.37 97.5979C382.37 97.5979 382.37 97.5979 382.43 97.4743C384.703 96.9022 386.607 95.3834 387.692 93.1574L387.813 92.9101Z",
    fill: "url(#paint5_linear_66_5014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.664 346.402C163.976 361.252 152.575 377.615 139.507 381.409C126.44 385.203 108.586 377.334 104.275 362.484C99.9631 347.634 109.014 327.059 122.082 323.264C139.507 318.205 155.353 331.552 159.664 346.402Z",
    fill: "#222327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.848 346.402C162.536 361.252 173.936 377.615 187.004 381.409C200.072 385.204 217.925 377.334 222.237 362.484C226.549 347.635 217.497 327.059 204.429 323.265C187.004 318.205 171.159 331.552 166.848 346.402Z",
    fill: "#222327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258 460.385C258 500.2 217.622 515 162.543 515C107.465 515 68 500.2 68 460.385C68 414.071 107.465 373 162.543 373C217.622 373 258 410.575 258 460.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.914 526.134C230.442 526.134 279.948 507.166 279.948 456.138C279.948 392.301 230.442 344.144 162.914 344.144C95.3853 344.144 47 396.781 47 456.138C47 507.166 95.3853 526.134 162.914 526.134ZM160.262 506.535C209.935 506.535 246.35 492.644 246.35 455.276C246.35 408.528 209.935 373.262 160.262 373.262C110.59 373.262 74.9986 411.809 74.9986 455.276C74.9986 492.644 110.59 506.535 160.262 506.535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.664 346.402C411.976 361.252 400.575 377.615 387.507 381.409C374.44 385.203 356.586 377.334 352.275 362.484C347.963 347.634 357.014 327.059 370.082 323.264C387.507 318.205 403.353 331.552 407.664 346.402Z",
    fill: "#222327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.848 346.402C410.536 361.252 421.936 377.615 435.004 381.409C448.072 385.204 465.925 377.334 470.237 362.484C474.549 347.635 465.497 327.059 452.429 323.265C435.004 318.205 419.159 331.552 414.848 346.402Z",
    fill: "#222327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506 460.385C506 500.2 465.622 515 410.543 515C355.465 515 316 500.2 316 460.385C316 414.071 355.465 373 410.543 373C465.622 373 506 410.575 506 460.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.914 526.134C478.442 526.134 527.948 507.166 527.948 456.138C527.948 392.301 478.442 344.144 410.914 344.144C343.385 344.144 295 396.781 295 456.138C295 507.166 343.385 526.134 410.914 526.134ZM408.262 506.535C457.935 506.535 494.35 492.644 494.35 455.276C494.35 408.528 457.935 373.262 408.262 373.262C358.59 373.262 322.999 411.809 322.999 455.276C322.999 492.644 358.59 506.535 408.262 506.535Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_5014",
    x1: 363,
    y1: 122.275,
    x2: 363,
    y2: 167.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF37BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF68CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_5014",
    x1: 323.958,
    y1: 88.6939,
    x2: 332.782,
    y2: 111.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF37BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF68CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_66_5014",
    x1: 378.015,
    y1: 78.7645,
    x2: 367.438,
    y2: 100.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF37BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF68CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_66_5014",
    x1: 363,
    y1: 122.275,
    x2: 363,
    y2: 167.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF37BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF68CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_66_5014",
    x1: 323.958,
    y1: 88.6939,
    x2: 332.782,
    y2: 111.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF37BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF68CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_66_5014",
    x1: 378.015,
    y1: 78.7645,
    x2: 367.438,
    y2: 100.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF37BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF68CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_5014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 588,
    height: 444,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHome01);
export default __webpack_public_path__ + "static/media/img_home_01.bd7a0e061e485d982ba4e4cb674645f8.svg";
export { ForwardRef as ReactComponent };